<template>
  <div class="cmp-catalog-statement-statement_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddAccountClicked"
            class="dt-icon v5 s1"
            src="static/buttons/add.svg"
            alt
          />
        </div>
      </div>
      <div class="search" style="max-width:350px">
        <InputField
          :value="basicFilter.searchString"
          :placeholder="'Search'"
          :config="{
            borderStyle: 'bottom',
            maxWidth:'200px',
            minWidth:'200px',
            width:'200px'
          }"
          @keyup="onSearchInputKeyup"
        />
        <DTIconButton
          :classNames="'search--advanced'"
          :text="'Advanced Search'"
          :style="{
            minWidth: '148px',
            maxWidth: '148px',
          }"
          icon="add-blue"
          @click="onAdvancedSearchClick"
        />
        <!-- <Dropdown
          :options="licenceStatusesTV"
          style="margin-top:-1px;margin-left:20px;min-width:150px"
          :placeholder="'Business Status'"
          deselect
          borderbottom
          :selected="
            licenceStatusesTV.find(e => e.value == basicFilter.licence_statuses)
          "
          v-on:selectedChange="e => onDropdownChange('licence_statuses', e)"
        /> -->
      
      </div>
      <div class="search-config--container">
        <div class="search-config">
          <SearchConBadge
            v-for="sconKey of filteredAdvancedSearchConfigKeys"
            :key="sconKey"
            v-bind="searchConfigKey(sconKey)"
            @delete="onSearchConDelete"
          />
        </div>
      </div>
    </div>

    <div class="dt-page--body">
      <NTable
        id="catalog-statement-statement_list"
        class="h1"
        :config="tableConfig"
        :headers="contactHeaders"
        :items="list"
         :loadingFlag="loadingFlag"
        @scrollnext="onAccountsNext"
      >
        <!-- @click="onClickStatement(item)" -->
        <template v-slot:item="{ item, tdcon }">
          <tr
            @click="onRowClicked(item)"
            :class="{
              selected: selectedRow(item)
            }"
           :title="item['tooltip_licence_status']"
          >
            <td v-bind="tdcon('licence_account')">
              <div class="ut-flex">
                <DtStatus
                  :statusTVList="statusTV"
                  :item="{ itemID:item.licence_account_id ,colorPropertyName:'licence_account_status_id',colorPropertyValue:item.licence_account_status_id,colorName:'status_colour',colorValue:item.status_colour,}"
                  @updateStatus="onStatusChange"
                />
                <div style="font-weight: bold;margin-left:3px">
                  <b>{{ item["licence_account_name"] }}</b>
                </div>
              </div>
              <!-- <div class="ut-flex">
                  <div
                    class="circle-status"
                    style="border:1px solid black;"
                    :style="{
                      backgroundColor: `#${item['status_colour']}`,
                      
                    }"
                  ></div>
                  <span style="font-weight: bold; margin-left: 3px">{{
                    item["licence_account_name"]
                  }}</span>
                </div> -->
              
            </td>
            <td v-bind="tdcon('licence_status')" >
              <span>{{ item["licence_status"] }}</span>
            </td>


            
            
            <!-- <td v-bind="tdcon('business_status')">
        
              <Dropdown
                :options="licenceStatusesTV"
                :placeholder="`${$t('Business Status')}`"
                :selected="
                  licenceStatusesTV.find(v => v.value == item.business_status)
                "
                v-on:selectedChange="
                  e => onDropDownUpdate('business_status', e, item)
                "
                :style="{
                  'min-height': '28px'
                }"
                deselect
                box
                :showExpandedLabel="false"
              ></Dropdown>
            </td> -->
            <td v-bind="tdcon('last_statement')">
              <span>{{ item["last_statement"] }}</span>

            </td>

            <td v-bind="tdcon('next_due')" >
              <div  v-if="item['next_statement']" class="ut-flex">
                <div class="dt-icon-container ">
                  <img
                  
                    @click.stop="e => emailLink(item)"
                    src="static/icons/email/email-grey.svg"
                    class="dt-icon v5 s2"
                  />
                  <!-- <div v-else style="width:30px;height:30px"></div> -->
                </div>
                <div>{{ item["next_statement"] }}</div>
              </div>

            </td>

            <td v-bind="tdcon('city')">
              <span>{{ item["city"] }}</span>
            </td>
            <td v-bind="tdcon('country')">
              <span>{{ item["country"] }}</span>
            </td>

            <td v-bind="tdcon('email')">
              <div  v-if="item['email']" class="ut-flex">
                <div class="dt-icon-container ">
                  <img
                   
                    @click.stop="e => emailLink(item)"
                    src="static/icons/email/email-grey.svg"
                    class="dt-icon v5 s2"
                  />
                  <!-- <div v-else style="width:30px;height:30px"></div> -->
                </div>
                <div>{{ item["email"] }}</div>
              </div>
            </td>

            <td v-bind="tdcon('options')">
              <img
                v-if="item['show_delete']==1"
                @click.stop="e => deleteAccount(item)"
                src="static/icons/delete.svg"
                class="dt-icon v5 s2 ut-center"
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>
    <DtPageStatusFloat :statusTV="statusTV" />
    <Sidewindow
      :value="licenceAccountsDetailsFlag"
      @closed="onCloseLicenceAccountsDetails"
    >
      <AccountSidewindow :licenceAccountsDetails="licenceAccountsDetails" />
    </Sidewindow>

    <ModalContainer :modalKey="'advanceSearch'" width="small">
      <AdvancedSearch
        :advancedSearchData="advancedSearchData"
        :initSearchFilter="searchFilter"
        @search="onAdvancedSearch"
        @cancelled="onCancel"
      />
    </ModalContainer>
    <ModalContainer
      @cancelled="onCancel"
      :modalKey="'addAccount'"
      :width="'400'"
    >
      <AddAccountModal
        @addLicenceAccount="addLicenceAccount"
        @cancelled="onCancel"
      />
    </ModalContainer>

    <ModalContainer
      @cancelled="onCancel"
      :modalKey="'createInvoiceProjects'"
      :width="'400'"
    >
      <CreateInvoiceModal @create="createInvoice" @cancelled="onCancel" />
    </ModalContainer>

    <ModalContainer
      @cancelled="onCancel"
      :modalKey="'duplicateLicence'"
      :width="'400'"
    >
      <DuplicateLicenceModal  
        @cancelled="onCancel" 
        @create="onInsertReleatedLicence"
      />
    </ModalContainer>

    <!-- <ModalContainer
      @cancelled="onCancel"
      :modalKey="'duplicateLicence'"
      :width="'400'"
    >
      <DuplicateLicenceModal  
        @cancelled="onCancel" 
        @create="onInsertReleatedLicence"
      />
    </ModalContainer> -->

    <ModalContainer 
      :modalKey="'createLicenceForm'" 
      :width="'small'"
    >
      
      <CreateLicenceForm 
        @cancelled="onCancel" 
        @create="onAddLicence"
      />
    
    </ModalContainer>

    <ModalContainer 
      :modalKey="'openInvoiceProjectForm'" 
      :width="'small'"
    >
      
      <InvoiceProjectForm 
        @cancelled="onCancel" 
     
      
      />
    
    </ModalContainer>

    <ModalContainer 
      :modalKey="'reminderModal'" 
      :width="'small'"
      @cancelled="onCancel" 
    >
      <ReminderModal 
        :msg="msg" 
        @sendEmail="sendEmail"
        @cancelled="onCancel" 
        
      />
    
    </ModalContainer>

    <ModalContainer 
      :modalKey="'newStatementModal'" 
      :width="'small'"
      @cancelled="onCancel" 
    >
      <NewStatementModal 
        @cancelled="onCancel" 
        @openNewForm2="openNewForm2"
      />
    
    </ModalContainer>

    <ModalContainer 
      :modalKey="'newStatementModal2'" 
      :width="'large'"
      @cancelled="onCancel" 
    >
      <NewStatementModal2 
        :requestPayload="modal2Data"
        @cancelled="onCancel" 
        @openNewForm2="openNewForm2"
      />
    
    </ModalContainer>



  </div>
</template>

<script>
// import Modal from '../../../../dt-plugins/modal/modal';
import { LicenceStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
//import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";

// import InputField from "@plugins/text-field/input-field";

import { ConfirmationService } from "@/dt-plugins/confirmation/confirmation.service";
import { createNTableConfig } from "../../../../plugins/datatable";

import { createTableHeader } from "../../../../plugins/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";

import {
  createModalMixin,
  closeModalRoute,
  openModalRoute2
} from "../../../../dt-plugins/modal/modal.mixin";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
// import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";

import Sidewindow from "@/dt-plugins/sidewindow/sidewindow";

import { createTV, tv } from "../../../../models/text-value.model";

import { mapGetterObject, mapActionObject } from "../../../../store/global";
import { licenceAccountsGetters } from "../../store/accounts/getters";
import { licenceAccountsActions } from "../../store/accounts/actions";
import {
  getlicenceAccountsDetailsSelectable,
  licenceAccountsListLDTRoutes,
  licencesListLDTRoutes
} from "../../router/routes";
import {
  onDetailsRowClicked,
  childOfOrEqualDetails,
  handleFromRoute
} from "../../../../utility/route";

import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
import AccountSidewindow from "./accounts-sidewindow";

import AddAccountModal from "./add-account-modal";

import CreateInvoiceModal from "./create-invoice-modal";

import DuplicateLicenceModal from "./duplicate-licence-modal.vue"


import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";
import InvoiceProjectForm from "./invoice-project-form-modal"
import { sendMail, sendMailHref } from "../../../../utility";
import { invoiceListLDTRoutes } from '../../../accounting/router/routes';
import { licenceAccountsService } from '../../services/licence-accounts.service';
import CreateLicenceForm from '../licences/create-licence-form.vue';
import ReminderModal from './reminder-modal.vue';
import { createAdvancedSearchHost } from "../../../../dt-plugins/advanced-search/advance-search.mixin";
import { licenceAccountListAdvancedSearchConfig } from './advanced-search.vue';
import NewStatementModal from './new-statement-modal.vue'
import NewStatementModal2 from './new-statement-modal2.vue'
import AdvancedSearch from './advanced-search.vue';
import DtPageStatusFloat from "@dtplugins/dtpage-status/dtpage-status-float";
import DtStatus from "@dtplugins/dt-status-dropdown/dt-status";
const LDTConfig = {
  entityName: "licence_account",
  ldtRoutes: licenceAccountsListLDTRoutes,
  detailsSelectableFunction: getlicenceAccountsDetailsSelectable,
  primaryKey: "licence_account_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.LicenceAccountsDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.LicenceAccountsDetails.FETCH.SINGLE
};

export default {
  components: {
    NTable,
    AddAccountModal,
    // InputField,
    // DTIconButton,
    ModalContainer,
    AccountSidewindow,
    CreateInvoiceModal,
    DuplicateLicenceModal,
    CreateLicenceForm,

    InvoiceProjectForm,
    Sidewindow,
    ReminderModal,
    AdvancedSearch,
    NewStatementModal,
    NewStatementModal2,
    DtPageStatusFloat,
    DtStatus
  },
  mounted: function() {},
  data: function() {
    return {
      selectedClickedLicenceAccount: null,
      msg:'',
      modal2Data:{},

      //defaultConfig: defaultConfig,
      searchType: "none" // release__standard_search, release__weekly_search, release__monthly_search
    };
  },
  mixins: [
    createLDTHost(LDTConfig),

    createFetchListMixin(ActionTypes.LicenceAccountsList.FETCH.ALL, 100),
    createModalMixin("addAccount"),
    createModalMixin("createInvoiceProjects"),
    createModalMixin("duplicateLicence"),
    createModalMixin("createLicenceForm"),
    createModalMixin("newStatementForm"),
    createModalMixin("newStatementForm2"),
    createModalMixin("openInvoiceProjectForm"),
    createModalMixin("reminderModal"),
    createAdvancedSearchHost( licenceAccountListAdvancedSearchConfig ),
    createModalMixin("advanceSearch"),
    createModalMixin("newStatementModal"),
    createModalMixin("newStatementModal2"),
    // createAdvancedSearchHost(releaseListAdvancedSearchConfig, {
    //   onBeforeAdvancedSearchFetch:
    //     "onBeforeAdvancedSearchFetch",
    // }),
  ],
  watch: {
    $route: {
      immediate: true,
      handler: function(to, from) {}
    }
  },
  computed: {
    ...mapGetterObject(storeNS, licenceAccountsGetters),
    filter: function() {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter
      };
    },
    statusTV: function () {
      return (
        this.licenceAccountsList?.licence_account_statuses?.map((e) => {
          return {
            text: e["label_status_name"],
            value: e["label_status_colour"]? e["label_status_colour"]: "000000",
            id: e["label_status_id"],
          };
        }) || []
      );
    },

    licenceAccountsDetailsFlag: function() {
      return childOfOrEqualDetails(licenceAccountsListLDTRoutes, this.$route);
    },

    licenceStatusesTV: function(params) {
      return createTV(
        this.licenceAccountsList?.licence_statuses,
        "licence_status_text",
        "licence_status_id"
      );
    },

    tableConfig: function() {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40
      });
    },
    list: function() {
      return this.licenceAccountsList?.licence_accounts || [];
    },

    contactHeaders: function() {
      return [
        createTableHeader("licence_account", {}),
        createTableHeader("licence_status", { }),
        createTableHeader("last_statement", {}),
        createTableHeader("next_due", { text:"Next Due"}),
        
        createTableHeader("city", {}),
        createTableHeader("country", {}),
        
        createTableHeader("email", {}),

        createTableHeader("options", { text: false, mw: 30 })
      ];
    },
    advancedSearchData: function() {


      return {
        licenceAccountStatusTV:createTV(this.advancedSearchResponse?.licence_account_statuses,"label_status_name","label_status_id"),
        licenceStatusTV:createTV(this.advancedSearchResponse?.licence_statuses,"label_status_name","label_status_id"),
      };
    }
    
  },
  methods: {
    ...mapActionObject(storeNS, licenceAccountsActions),
    fetchAdvancedSearchData :async function(){
      const advancedSearchData = await licenceAccountsService.licenceAccAdvancedSearchModalData();
  
      this.advancedSearchResponse = advancedSearchData?.data;

      console.log(":::::::::::::::this.advancedSearchResponse",this.advancedSearchResponse)

      this[ActionTypes.LicenceAccountsList.SET.ALL](this.advancedSearchResponse.licence_account_statuses);
    },
    defaultBasicFilter() {
      //<-- Needed for BasicSearch. Provide the basic Filter Object. Supports String/Boolean/Number
      return {
        searchString: undefined,
        licence_statuses: undefined,
        royalty_period: undefined,
        invoice_project: undefined,
        statement_type: undefined
      };
    },
    onAddAccountClicked: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_account"
        }
      });
    },

    addLicenceAccount:async function(payload) {
      const primary_key = await this[ActionTypes.LicenceAccountsList.INSERT.SINGLE](payload);
      this.$router.push({
        name: licenceAccountsListLDTRoutes.names.tab,
        params: {
          licence_account_id: primary_key,
          tab: "overview"
        }
      });

      this.onCancel();
    },
    onDropDownUpdate: function(name, value, item) {
      const payload = {
        kVal: item.licence_account_id,
        name: name,
        value: value.value
      };
      this[ActionTypes.LicenceAccountsList.UPDATE.SINGLE](payload);
    },
    onDropdownChange: function(name, value) {
      // <-- Normal Form Handling Methods
      this.basicFilter[name] = value.value;

      this.fetchListReset();
    },
    onTextFieldChange: function(event, item) {
      console.log(event, item);
      const payload = {
        kVal: item.licence_account_id,
        name: event.name,
        value: event.value
      };
      this[ActionTypes.LicenceAccountsList.UPDATE.SINGLE](payload);
    },
    deleteAccount:async function(item) {
      const confirmationResult = await confirmDelete(
        "Licence Account",
        item.licence_account_name
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.LicenceAccountsList.DELETE.SINGLE](item);
      }
      // ConfirmationService.create({
      //   subject: this.$t("delete_licence_account_msg"),
      //   model: true,
      //   width: 500,
      //   completed: res => {
      //     switch (res) {
      //       case "OK": {
      //         this[ActionTypes.LicenceAccountsList.DELETE.SINGLE](item);
      //         // console.log(item);
      //         break;
      //       }
      //       default: {
      //       }
      //     }
      //   }
      // });
    },
    selectedRow: function(item) {
      return (
        this.selectedClickedLicenceAccount &&
        this.selectedClickedLicenceAccount["licence_account_id"] ==
          item["licence_account_id"]
      );
    },

    emailLink:async function(item) {
      
      const checkMsg = await licenceAccountsService.isLicenceReminderSentout(item.licence_account_id);

      const { msg } = checkMsg.data;

      console.log("RES",checkMsg)

      this.msg = msg;

      
      this.$router.push({
        ...this.$route,
        query: {
          modal: "reminder_modal",
          licence_account_id:item.licence_account_id
        }
      });
      
      // const body = "";

      // const subject = "Licence Reminder " + item.licence_account_name;

      // const mails = [item.email];

      // console.log("subject,body,recepient", item);

      // sendMailHref({ subject, body, mails });
      //sendMail({ subject, body, mails });
    },

    sendEmail:async function(payload){
      
      const res = await licenceAccountsService.sendReminderEmail(payload); 

      const { email_to , email_text ,SUBJECT } = res.data.msg;

      console.log({ email_to , email_text ,SUBJECT })

      sendMailHref({ subject:SUBJECT||'' , body:email_text||'' ,mails: [email_to]||[]});
      this.onCancel();
    },
    onRowClicked: function(item) {
      if (this.loadingFlag) {
        return;
      }
      this.selectedClickedLicenceAccount = item;
      this.$router.push({
        name: licenceAccountsListLDTRoutes.names.tab,
        params: {
          licence_account_id: item.licence_account_id,
          tab: "overview"
        }
      });
    },
    onCloseLicenceAccountsDetails: function() {
      this.selectedClickedLicenceAccount = null;
      this.fetchListReset();
      handleFromRoute(this, () => {
        this.$router.push({
          name: licenceAccountsListLDTRoutes.names.list
        });
      });
    },

    createInvoice:async function(payload) {
      console.log(payload);
      await this[ActionTypes.LicenceAccountInvoices.SET.ALL](payload);
      const { licence_lines, licence_account_id,invoice_project_id } = payload;
      //const resDataInvoice = await licenceAccountsService.createInvoices(licence_account_id,invoice_project_id,licence_lines);

      const resDataInvoice = await licenceAccountsService.createInvoiceFromLicenceAccount(invoice_project_id,licence_lines,licence_account_id);

      console.log(":PPPPPP",resDataInvoice)

      const resDataLicenceLines=await licenceAccountsService.lcncAccDetailsTabInvoices(licence_account_id);

      this.$router.push({
        name:invoiceListLDTRoutes.names.tab,
        params: {
          invoice_id: resDataInvoice.data.invoice_id,
          tab: "overview",
        },
      });
    },

    onInsertReleatedLicence:async function(payload){
      const new_licence_id = await this[ActionTypes.AccountRelatedLicence.INSERT.SINGLE](payload);
      this.onCancel();
      this.$router.push({
        name: licencesListLDTRoutes.names.tab,
        params: {
          licence_id: new_licence_id,
          tab: "overview",
        },
      });
   
    },

    onAccountsNext: function(value) {
      this.scrollSubject.next(value);
    },

    onCancel: function() {
      closeModalRoute(this);
    },
    onAddLicence:async function(payload){
      const l_id = await this[ActionTypes.AccountRelatedLicence.INSERT.SINGLE]({ ...payload, duplicate:false })
      this.onCancel();
      this.$router.push({
        name: licencesListLDTRoutes.names.tab,
        params: {
          licence_id: l_id,
          tab: "overview",
        },
      });
    },

    openNewForm2:function(payload){
       this.modal2Data = { ...payload }       
       this.onCancel();
       openModalRoute2(this,"newStatementModal2",{
          ...payload
       });
     
    },

    onOpenInvoiceProjectForm:function(payload){
      this.onCancel();
      openModalRoute2(this,"openInvoiceProjectForm",{
        ...payload
      });
    
    },
    onAdvancedSearchClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "advance_search",
        },
      });
    },

    onStatusChange: function (payload) {
      //const item = this.selectedReleaseDetails;
      console.log({...payload},"STATUS")

      const statusPayload= {
        kVal: payload.itemID,
        name: 'status',
        value: payload
      };
      this[ActionTypes.LicenceAccountsList.UPDATE.SINGLE](statusPayload);
      
      //this[ActionTypes.ReleaseList.UPDATE.SINGLE](payload);
      //console.log(payload,payload)
    },

    
  }
};
</script>

<style lang="scss">
.cmp-catalog-statement-statement_list {
  .dt-page--body {
    --offset: 190px;
  }
  td.file_name a {
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
  // .invoicelist-footer {
  //   border-top: 1px solid var(--sprt-5);

  //   .invoice_status_list {
  //     display: flex;
  //     .status {
  //       margin-top: 15px;
  //       display: flex;
  //       // max-width: 150px;
  //       flex: 0.5;
  //       .circle {
  //         width: 15px;
  //         height: 15px;

  //         margin-right: 10px;
  //         margin-top: 2.5px;
  //       }
  //       .status-name {
  //         flex: 1;
  //       }
  //     }
  //   }
  // }
}
</style>
